import { render, staticRenderFns } from "./PerfilMenuAssociacaoPage.vue?vue&type=template&id=17925ade"
import script from "./PerfilMenuAssociacaoPage.vue?vue&type=script&lang=js"
export * from "./PerfilMenuAssociacaoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports